/**
 * 顶层互斥 shallow merge：每个 top-level namespace 只能出现在一个源中。
 * 若两个源定义相同顶层 key，则 throw Error。
 */
export function mergeLocales(
  ...sources: Record<string, unknown>[]
): Record<string, unknown> {
  const merged: Record<string, unknown> = {}

  for (const source of sources) {
    for (const key of Object.keys(source)) {
      if (key in merged) {
        throw new Error(
          `Locale merge conflict: top-level key "${key}" appears in multiple sources`,
        )
      }
      merged[key] = source[key]
    }
  }

  return merged
}
